import { richTextResolver} from "@storyblok/react";

export const renderRichText = (content: any): string => {
  if (!content || !content.content) {
    return '';
  }

  const { render } = richTextResolver();

  try {
    return render(content) as string;
  } catch (error) {
    console.error('Error rendering rich text:', error);
    return '';
  }
};